import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const tabs = [
    { id: 'overview',   label: 'Overview',   path: '/dashboard/overview' },
    { id: 'resumes',    label: 'Resumes',    path: '/dashboard/resumes' },
    { id: 'analytics',  label: 'Analytics',  path: '/dashboard/analytics' },
    { id: 'messages',   label: 'Messages',   path: '/dashboard/messages' },
    { id: 'profile',    label: 'Profile',    path: '/dashboard/profile' },
];

export default function DashboardTabs() {
    const location = useLocation();

    return (
        <div className="flex items-center gap-8 h-full">
            {tabs.map((tab) => {
                const isActive = location.pathname.includes(tab.path);

                return (
                    <Link
                        key={tab.id}
                        to={tab.path}
                        className="relative h-full flex items-center"
                    >
                        <span className={cn(
                            "text-sm font-medium transition-colors duration-200",
                            isActive ? "text-white" : "text-zinc-400 hover:text-zinc-200"
                        )}>
                            {tab.label}
                            {tab.badge && (
                                <span className="ml-2 px-1.5 py-0.5 text-[10px] uppercase font-bold tracking-wider rounded bg-white/10 text-white border border-white/20">
                                    {tab.badge}
                                </span>
                            )}
                        </span>

                        {isActive && (
                            <motion.div
                                layoutId="activeTab"
                                className="absolute bottom-0 left-0 right-0 h-[2px] bg-white shadow-[0_0_8px_rgba(255,255,255,0.6)]"
                                initial={false}
                                transition={{ type: "spring", stiffness: 500, damping: 30 }}
                            />
                        )}
                    </Link>
                );
            })}
        </div>
    );
}
